﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const reselect_1 = require("reselect");
const operational_context_client_1 = require("@its-suite/operational-context-client");
const permissionsState = (state) => state.session ? state.session.permissions : [];
const visibleOrganizationsState = (state) => state.session ? state.session.visibleOrganizations : [];
class SessionSelector {
    static sessionHasRequiredPermissions(requiredPermissions, sessionPermissions) {
        return SessionSelector.hasSuperAdminPermission(sessionPermissions) || SessionSelector.allPermissionsMatch(requiredPermissions, sessionPermissions);
    }
    static allPermissionsMatch(requiredPermissions, sessionPermissions) {
        let somePermissionNotFound = requiredPermissions.some(permission => sessionPermissions.indexOf(permission) === -1);
        return !somePermissionNotFound;
    }
    static hasSuperAdminPermission(sessionPermissions) {
        return sessionPermissions.indexOf(operational_context_client_1.PermissionName.SuperAdmin.toString()) !== -1;
    }
}
exports.SessionSelector = SessionSelector;
SessionSelector.isSuperAdmin = reselect_1.createSelector(permissionsState, sessionPermissions => SessionSelector.hasSuperAdminPermission(sessionPermissions));
SessionSelector.visibleOrganizations = reselect_1.createSelector(visibleOrganizationsState, visibleOrganizations => visibleOrganizations.map(vo => vo.organizationAppId));
SessionSelector.editableOrganizations = reselect_1.createSelector(visibleOrganizationsState, visibleOrganizations => visibleOrganizations.filter(vo => vo.editable).map(vo => vo.organizationAppId));
SessionSelector.hasPermissions = (requiredPermissions) => {
    return reselect_1.createSelector(permissionsState, sessionPermissions => SessionSelector.sessionHasRequiredPermissions(requiredPermissions, sessionPermissions));
};
//# sourceMappingURL=sessionSelectors.js.map